import React from "react";
import PropTypes from "prop-types";
import classes from "./headingWithList.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import {
  BlueCheck,
  cancelIcon,
  CancelSymbolRed,
  CheckSymbolBlue,
} from "../../constant/imagePath";
import { Row, Col } from "react-bootstrap";
import { ReactSVG } from "react-svg";

export const HeadingWithList = ({ heading, lists, tagline }) => {
  return (
    <div className={`${classes.headingWithList}`}>
      <h5
        style={{
          ...Fonts.h5,
          color: Colors.neutralShadesOfNero,
          marginBottom: tagline && "8px",
        }}
      >
        {heading}
      </h5>
      {tagline && (
        <p
          className={`${[classes.tagline].join(" ")}`}
          style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
        >
          {tagline}
        </p>
      )}
      <Row>
        {lists?.map((item) => {
          return (
            <Col md={6} sm={6} xs={6}>
              <div
                className={`${[classes.listItem].join(" ")}`}
                style={{
                  ...Fonts.p1,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                <ReactSVG
                  src={item?.icon ? CheckSymbolBlue : CancelSymbolRed}
                  beforeInjection={(svg) => svg.classList.add(classes.icon)}
                />
                <span>{item?.title}</span>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

HeadingWithList.propType = {
  heading: PropTypes.string,
  lists: PropTypes.array,
  tagline: PropTypes.string,
};

HeadingWithList.defaultProps = {
  heading: "What's provided",
  lists: [
    { title: "Grips", icon: true },
    { title: "Racquet string", icon: true },
    { title: "Tennis racquet", icon: true },
    { title: "Tennis Balls", icon: true },
    { title: "Practice Skirt", icon: true },
    { title: "Sweatbands", icon: true },
  ],
  tagline:
    "Things that the coach does not provide should be taken by yourself.",
};
